import { Route, Routes as SwitchRoutes } from 'react-router-dom'

import Home from '../views/Home'
import Login from '../views/Login'
import Redirect from '../views/Redirect'
import Client from '../views/Client'

const Routes = () => (
  <SwitchRoutes>
    <Route path="/:commerce" element={<Home />} />
    <Route path="/:commerce/signIn" element={<Login />} />
    <Route path="/:commerce/signUp" element={<Client />} />
    <Route path="/:commerce/redirect" element={<Redirect />} />
  </SwitchRoutes>
)

export default Routes
